import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62 62"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    >
      <path d="M18.9 32.6v7.9l11.9 6.6 11.9-6.6v-7.9m-23.8-7.7l11.9-6.6 11.9 6.6m-23.8 0L12 21.1l11.7-6.6 7 3.9" />
      <path d="M42.6 24.9l6.9-3.8-11.7-6.6-7 3.9m11.8 6.5l6.9 3.8-11.7 6.7-7-3.9 11.8-6.6zM30.8 47.1V31.5l-7 3.9L12 28.7l6.9-3.8 11.9 6.6" />
    </svg>
  </span>
);

export default icon;
